import { useState } from 'react';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const [showAboutUs, setShowAboutUs] = useState(false);
  const [showModal, setShowModal] = useState<string | null>(null);

  const handleHotelBookings = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleDestinationClick = (destination: string) => {
    const destinationsSection = document.getElementById('destinations');
    if (destinationsSection) {
      destinationsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleContactUs = () => {
    window.open('tel:+919700644857', '_self');
  };

  const handleEmailContact = () => {
    window.open('mailto:info@maxjourneys.in?subject=Travel Inquiry - MaxJourneys&body=Dear MaxJourneys Team,%0A%0AI am interested in learning more about your travel services. Please provide information about:%0A%0A- Flight bookings%0A- Hotel reservations%0A- Tour packages%0A- Other travel services%0A%0AThank you for your time.%0A%0ABest regards', '_blank');
  };

  const handleCallForCancellation = () => {
    window.open('tel:+919700644857', '_self');
  };

  const handleSocialMedia = (platform: string) => {
    const urls = {
      facebook: 'https://facebook.com/maxjourneys',
      twitter: 'https://twitter.com/maxjourneys',
      instagram: 'https://instagram.com/maxjourneys',
      linkedin: 'https://linkedin.com/company/maxjourneys'
    };
    window.open(urls[platform as keyof typeof urls], '_blank');
  };

  const renderModal = () => {
    if (!showModal) return null;

    const modalContent = {
      'help-center': {
        title: 'Help Center',
        content: (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-blue-50 p-6 rounded-lg">
                <h4 className="text-lg font-bold mb-3 text-blue-800">Booking Support</h4>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-center"><i className="ri-check-line text-green-600 mr-2"></i>How to book flights</li>
                  <li className="flex items-center"><i className="ri-check-line text-green-600 mr-2"></i>Payment methods</li>
                  <li className="flex items-center"><i className="ri-check-line text-green-600 mr-2"></i>Booking modifications</li>
                  <li className="flex items-center"><i className="ri-check-line text-green-600 mr-2"></i>Group bookings</li>
                </ul>
              </div>
              <div className="bg-green-50 p-6 rounded-lg">
                <h4 className="text-lg font-bold mb-3 text-green-800">Travel Support</h4>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-center"><i className="ri-check-line text-blue-600 mr-2"></i>Travel documentation</li>
                  <li className="flex items-center"><i className="ri-check-line text-blue-600 mr-2"></i>Visa requirements</li>
                  <li className="flex items-center"><i className="ri-check-line text-blue-600 mr-2"></i>Travel insurance</li>
                  <li className="flex items-center"><i className="ri-check-line text-blue-600 mr-2"></i>Emergency assistance</li>
                </ul>
              </div>
            </div>
            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <p className="text-gray-700 mb-4">Need immediate assistance?</p>
              <div className="flex justify-center space-x-4">
                <button 
                  onClick={handleContactUs}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-line mr-2"></i>Call Now
                </button>
                <button 
                  onClick={handleEmailContact}
                  className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-mail-line mr-2"></i>Email Us
                </button>
              </div>
            </div>
          </div>
        )
      },
      'travel-guide': {
        title: 'Travel Guide',
        content: (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="bg-orange-50 p-4 rounded-lg text-center">
                <i className="ri-map-line text-3xl text-orange-600 mb-3"></i>
                <h4 className="font-bold text-orange-800 mb-2">Destination Guides</h4>
                <p className="text-sm text-gray-700">Complete travel information for popular Indian destinations</p>
              </div>
              <div className="bg-blue-50 p-4 rounded-lg text-center">
                <i className="ri-calendar-line text-3xl text-blue-600 mb-3"></i>
                <h4 className="font-bold text-blue-800 mb-2">Best Time to Visit</h4>
                <p className="text-sm text-gray-700">Seasonal guides and weather information</p>
              </div>
              <div className="bg-green-50 p-4 rounded-lg text-center">
                <i className="ri-restaurant-line text-3xl text-green-600 mb-3"></i>
                <h4 className="font-bold text-green-800 mb-2">Local Experiences</h4>
                <p className="text-sm text-gray-700">Authentic food, culture, and activities</p>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <h4 className="text-lg font-bold mb-4">Popular Travel Tips</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <ul className="space-y-2">
                  <li className="flex items-start"><i className="ri-arrow-right-s-line text-blue-600 mr-2 mt-1"></i><span className="text-gray-700">Budget planning for Indian destinations</span></li>
                  <li className="flex items-start"><i className="ri-arrow-right-s-line text-blue-600 mr-2 mt-1"></i><span className="text-gray-700">Essential packing checklist</span></li>
                  <li className="flex items-start"><i className="ri-arrow-right-s-line text-blue-600 mr-2 mt-1"></i><span className="text-gray-700">Transportation options</span></li>
                </ul>
                <ul className="space-y-2">
                  <li className="flex items-start"><i className="ri-arrow-right-s-line text-blue-600 mr-2 mt-1"></i><span className="text-gray-700">Cultural etiquette and customs</span></li>
                  <li className="flex items-start"><i className="ri-arrow-right-s-line text-blue-600 mr-2 mt-1"></i><span className="text-gray-700">Health and safety guidelines</span></li>
                  <li className="flex items-start"><i className="ri-arrow-right-s-line text-blue-600 mr-2 mt-1"></i><span className="text-gray-700">Local language basics</span></li>
                </ul>
              </div>
            </div>
          </div>
        )
      },
      'terms': {
        title: 'Terms & Conditions',
        content: (
          <div className="space-y-6 max-h-96 overflow-y-auto">
            <div className="space-y-4">
              <div>
                <h4 className="text-lg font-bold mb-2 text-blue-800">1. Booking Terms</h4>
                <p className="text-gray-700 text-sm leading-relaxed">All bookings are subject to availability and confirmation. Prices are subject to change until booking is confirmed and payment is received.</p>
              </div>
              <div>
                <h4 className="text-lg font-bold mb-2 text-blue-800">2. Payment Policy</h4>
                <p className="text-gray-700 text-sm leading-relaxed">Full payment is required at the time of booking. We accept all major credit cards, debit cards, and online banking payments.</p>
              </div>
              <div>
                <h4 className="text-lg font-bold mb-2 text-blue-800">3. Cancellation Policy</h4>
                <p className="text-gray-700 text-sm leading-relaxed">Cancellation charges apply as per airline/hotel policies. Processing fees may apply for all cancellations and modifications.</p>
              </div>
              <div>
                <h4 className="text-lg font-bold mb-2 text-blue-800">4. Travel Documentation</h4>
                <p className="text-gray-700 text-sm leading-relaxed">Travelers are responsible for ensuring valid travel documents including passport, visa, and health certificates as required.</p>
              </div>
              <div>
                <h4 className="text-lg font-bold mb-2 text-blue-800">5. Liability</h4>
                <p className="text-gray-700 text-sm leading-relaxed">MaxJourneys acts as an intermediary between customers and service providers. Our liability is limited to the booking amount.</p>
              </div>
            </div>
          </div>
        )
      },
      'privacy': {
        title: 'Privacy Policy',
        content: (
          <div className="space-y-6 max-h-96 overflow-y-auto">
            <div className="space-y-4">
              <div>
                <h4 className="text-lg font-bold mb-2 text-green-800">Information We Collect</h4>
                <p className="text-gray-700 text-sm leading-relaxed">We collect personal information necessary for booking travel services including name, contact details, passport information, and payment details.</p>
              </div>
              <div>
                <h4 className="text-lg font-bold mb-2 text-green-800">How We Use Your Information</h4>
                <p className="text-gray-700 text-sm leading-relaxed">Your information is used to process bookings, provide customer support, send booking confirmations, and improve our services.</p>
              </div>
              <div>
                <h4 className="text-lg font-bold mb-2 text-green-800">Data Security</h4>
                <p className="text-gray-700 text-sm leading-relaxed">We implement industry-standard security measures to protect your personal information and payment details.</p>
              </div>
              <div>
                <h4 className="text-lg font-bold mb-2 text-green-800">Third-Party Sharing</h4>
                <p className="text-gray-700 text-sm leading-relaxed">We share information only with trusted partners necessary for completing your travel bookings and providing services.</p>
              </div>
              <div>
                <h4 className="text-lg font-bold mb-2 text-green-800">Your Rights</h4>
                <p className="text-gray-700 text-sm leading-relaxed">You have the right to access, update, or delete your personal information. Contact us for any privacy-related concerns.</p>
              </div>
            </div>
          </div>
        )
      },
      'cancellation': {
        title: 'Cancellation Policy',
        content: (
          <div className="space-y-6">
            <div className="bg-red-50 p-4 rounded-lg">
              <h4 className="text-lg font-bold mb-2 text-red-800">Flight Cancellations</h4>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start"><i className="ri-arrow-right-s-line text-red-600 mr-2 mt-1"></i>More than 24 hours: Airline charges + ₹500 processing fee</li>
                <li className="flex items-start"><i className="ri-arrow-right-s-line text-red-600 mr-2 mt-1"></i>Less than 24 hours: Airline charges + ₹1000 processing fee</li>
                <li className="flex items-start"><i className="ri-arrow-right-s-line text-red-600 mr-2 mt-1"></i>No-show: Full cancellation charges apply</li>
              </ul>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg">
              <h4 className="text-lg font-bold mb-2 text-blue-800">Hotel Cancellations</h4>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start"><i className="ri-arrow-right-s-line text-blue-600 mr-2 mt-1"></i>More than 48 hours: Free cancellation</li>
                <li className="flex items-start"><i className="ri-arrow-right-s-line text-blue-600 mr-2 mt-1"></i>24-48 hours: 50% of booking amount</li>
                <li className="flex items-start"><i className="ri-arrow-right-s-line text-blue-600 mr-2 mt-1"></i>Less than 24 hours: Full booking amount</li>
              </ul>
            </div>
            <div className="bg-green-50 p-4 rounded-lg">
              <h4 className="text-lg font-bold mb-2 text-green-800">Package Cancellations</h4>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start"><i className="ri-arrow-right-s-line text-green-600 mr-2 mt-1"></i>More than 15 days: 10% of package cost</li>
                <li className="flex items-start"><i className="ri-arrow-right-s-line text-green-600 mr-2 mt-1"></i>8-15 days: 25% of package cost</li>
                <li className="flex items-start"><i className="ri-arrow-right-s-line text-green-600 mr-2 mt-1"></i>Less than 7 days: 50% of package cost</li>
              </ul>
            </div>
            <div className="text-center p-4 bg-yellow-50 rounded-lg">
              <p className="text-sm text-gray-700 mb-3"><strong>Refund Timeline:</strong> 7-10 working days from cancellation date</p>
              <button 
                onClick={handleCallForCancellation}
                className="bg-yellow-600 hover:bg-yellow-700 text-white px-6 py-2 rounded-lg cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>Call for Cancellation
              </button>
            </div>
          </div>
        )
      },
      'careers': {
        title: 'Careers at MaxJourneys',
        content: (
          <div className="space-y-6">
            <div className="text-center mb-6">
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Join Our Travel Family</h3>
              <p className="text-gray-700">Build your career with India's leading travel company</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-blue-50 p-6 rounded-lg">
                <h4 className="text-lg font-bold mb-3 text-blue-800">Current Openings</h4>
                <ul className="space-y-3">
                  <li className="flex items-center justify-between">
                    <span className="text-gray-700">Travel Consultant</span>
                    <span className="text-sm text-blue-600">5 positions</span>
                  </li>
                  <li className="flex items-center justify-between">
                    <span className="text-gray-700">Customer Support Executive</span>
                    <span className="text-sm text-blue-600">3 positions</span>
                  </li>
                  <li className="flex items-center justify-between">
                    <span className="text-gray-700">Marketing Executive</span>
                    <span className="text-sm text-blue-600">2 positions</span>
                  </li>
                  <li className="flex items-center justify-between">
                    <span className="text-gray-700">Tour Guide</span>
                    <span className="text-sm text-blue-600">8 positions</span>
                  </li>
                </ul>
              </div>
              <div className="bg-green-50 p-6 rounded-lg">
                <h4 className="text-lg font-bold mb-3 text-green-800">Why Work With Us?</h4>
                <ul className="space-y-2">
                  <li className="flex items-center"><i className="ri-check-line text-green-600 mr-2"></i><span className="text-gray-700">Competitive salary packages</span></li>
                  <li className="flex items-center"><i className="ri-check-line text-green-600 mr-2"></i><span className="text-gray-700">Travel benefits & discounts</span></li>
                  <li className="flex items-center"><i className="ri-check-line text-green-600 mr-2"></i><span className="text-gray-700">Professional growth opportunities</span></li>
                  <li className="flex items-center"><i className="ri-check-line text-green-600 mr-2"></i><span className="text-gray-700">Flexible working hours</span></li>
                  <li className="flex items-center"><i className="ri-check-line text-green-600 mr-2"></i><span className="text-gray-700">Health insurance coverage</span></li>
                </ul>
              </div>
            </div>
            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <p className="text-gray-700 mb-4">Ready to start your journey with us?</p>
              <button 
                onClick={handleEmailContact}
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-line mr-2"></i>Send Your Resume
              </button>
            </div>
          </div>
        )
      }
    };

    const content = modalContent[showModal as keyof typeof modalContent];
    if (!content) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white text-gray-900 rounded-lg max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto shadow-2xl">
          <div className="sticky top-0 bg-white border-b px-8 py-6 flex justify-between items-center">
            <h2 className="text-3xl font-bold text-gray-900">{content.title}</h2>
            <button
              onClick={() => setShowModal(null)}
              className="w-10 h-10 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer rounded-full hover:bg-gray-100 transition-colors"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
          </div>
          <div className="p-8">
            {content.content}
            <div className="mt-8 pt-6 border-t text-center">
              <button 
                onClick={() => setShowModal(null)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const footerSections = [
    {
      title: 'Services',
      links: [
        { name: 'Hotel Bookings', action: handleHotelBookings },
        { name: 'Car Rentals', action: () => setShowModal('car-rentals') }, 
        { name: 'Visa Services', action: () => setShowModal('visa-services') }, 
        { name: 'Travel Insurance', action: () => setShowModal('travel-insurance') }, 
        { name: 'Tour Packages', action: () => setShowModal('tour-packages') }, 
        { name: 'Railway Bookings', action: () => setShowModal('railway-bookings') }
      ]
    },
    {
      title: 'Destinations',
      links: [
        { name: 'Kerala Backwaters', action: () => handleDestinationClick('kerala') }, 
        { name: 'Rajasthan Tours', action: () => handleDestinationClick('rajasthan') }, 
        { name: 'Goa Beaches', action: () => handleDestinationClick('goa') }, 
        { name: 'Himachal Adventures', action: () => handleDestinationClick('himachal') }, 
        { name: 'Tamil Nadu Temples', action: () => handleDestinationClick('tamil-nadu') }, 
        { name: 'Golden Triangle', action: () => handleDestinationClick('golden-triangle') }
      ]
    },
    {
      title: 'Support',
      links: [
        { name: 'Help Center', action: () => setShowModal('help-center') },
        { name: 'Contact Us', action: handleContactUs },
        { name: 'Travel Guide', action: () => setShowModal('travel-guide') },
        { name: 'Terms & Conditions', action: () => setShowModal('terms') },
        { name: 'Privacy Policy', action: () => setShowModal('privacy') },
        { name: 'Cancellation Policy', action: () => setShowModal('cancellation') }
      ]
    },
    {
      title: 'Company',
      links: [
        { name: 'About Us', action: () => setShowAboutUs(true) },
        { name: 'Careers', action: () => setShowModal('careers') }, 
        { name: 'Press', action: () => setShowModal('press') }, 
        { name: 'Partners', action: () => setShowModal('partners') }, 
        { name: 'Travel Agents', action: () => setShowModal('travel-agents') }, 
        { name: 'Franchise', action: () => setShowModal('franchise') }
      ]
    }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-1">
            <img 
              src="https://static.readdy.ai/image/11d8e4935baf92f9506f92a91c4432fc/decf9e9f5597a086516483b31d863714.jfif" 
              alt="MaxJourneys Logo" 
              className="h-16 w-auto mb-6"
            />
            <p className="text-gray-300 mb-8 text-lg leading-relaxed">
              Your trusted travel partner in India. We make your journey memorable with our comprehensive travel services across the nation.
            </p>
            <div className="flex space-x-5">
              <button 
                onClick={() => handleSocialMedia('facebook')}
                className="w-12 h-12 flex items-center justify-center bg-blue-600 rounded-full cursor-pointer hover:bg-blue-700 transition-colors"
              >
                <i className="fab fa-facebook-f text-lg"></i>
              </button>
              <button 
                onClick={() => handleSocialMedia('twitter')}
                className="w-12 h-12 flex items-center justify-center bg-blue-400 rounded-full cursor-pointer hover:bg-blue-500 transition-colors"
              >
                <i className="fab fa-twitter text-lg"></i>
              </button>
              <button 
                onClick={() => handleSocialMedia('instagram')}
                className="w-12 h-12 flex items-center justify-center bg-pink-600 rounded-full cursor-pointer hover:bg-pink-700 transition-colors"
              >
                <i className="fab fa-instagram text-lg"></i>
              </button>
              <button 
                onClick={() => handleSocialMedia('linkedin')}
                className="w-12 h-12 flex items-center justify-center bg-blue-800 rounded-full cursor-pointer hover:bg-blue-900 transition-colors"
              >
                <i className="fab fa-linkedin-in text-lg"></i>
              </button>
            </div>
          </div>

          {footerSections.map((section) => (
            <div key={section.title}>
              <h4 className="text-xl font-semibold mb-6">{section.title}</h4>
              <ul className="space-y-3">
                {section.links.map((link, index) => (
                  <li key={link.name}>
                    <button 
                      onClick={link.action}
                      className="text-gray-300 hover:text-white transition-colors cursor-pointer text-left text-lg w-full"
                    >
                      {link.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-800 mt-16 pt-10">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-300 text-lg">
              © {currentYear} MaxJourneys. All rights reserved.
            </p>
            <div className="flex items-center space-x-8 mt-6 md:mt-0">
              <button 
                onClick={() => setShowModal('privacy')}
                className="text-gray-300 hover:text-white text-lg cursor-pointer"
              >
                Privacy Policy
              </button>
              <button 
                onClick={() => setShowModal('terms')}
                className="text-gray-300 hover:text-white text-lg cursor-pointer"
              >
                Terms of Service
              </button>
              <button 
                onClick={() => setShowModal('cookies')}
                className="text-gray-300 hover:text-white text-lg cursor-pointer"
              >
                Cookie Policy
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* About Us Popup */}
      {showAboutUs && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white text-gray-900 rounded-lg max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto shadow-2xl">
            <div className="sticky top-0 bg-white border-b px-8 py-6 flex justify-between items-center">
              <h2 className="text-3xl font-bold text-gray-900">About MaxJourneys</h2>
              <button
                onClick={() => setShowAboutUs(false)}
                className="w-10 h-10 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer rounded-full hover:bg-gray-100 transition-colors"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            
            <div className="p-8">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
                <div>
                  <img 
                    src="https://readdy.ai/api/search-image?query=professional%20Indian%20travel%20company%20office%20with%20friendly%20staff%2C%20modern%20travel%20agency%20interior%2C%20Indian%20travel%20consultants%20helping%20customers%2C%20diverse%20team%20of%20travel%20experts%2C%20warm%20welcoming%20atmosphere%2C%20contemporary%20office%20design%20with%20travel%20posters%2C%20customer%20service%20excellence%20in%20India%20travel%20industry&width=600&height=400&seq=about-maxjourneys&orientation=landscape"
                    alt="MaxJourneys Team"
                    className="w-full h-64 object-cover rounded-lg"
                  />
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-4 text-blue-600">Your Trusted Travel Partner</h3>
                  <p className="text-gray-700 mb-4 leading-relaxed">
                    MaxJourneys has been India's premier travel companion for over a decade, specializing in creating unforgettable experiences across the incredible subcontinent. We understand that every journey is unique, and we're dedicated to crafting personalized travel solutions that exceed your expectations.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    From the snow-capped peaks of the Himalayas to the pristine beaches of Goa, from the royal palaces of Rajasthan to the backwaters of Kerala, we bring you closer to India's diverse landscapes, rich heritage, and vibrant culture.
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div className="text-center p-6 bg-blue-50 rounded-lg">
                  <div className="w-16 h-16 flex items-center justify-center bg-blue-600 rounded-full mx-auto mb-4">
                    <i className="ri-award-line text-2xl text-white"></i>
                  </div>
                  <h4 className="text-xl font-bold mb-2">10+ Years Experience</h4>
                  <p className="text-gray-600">Serving travelers with excellence since 2014</p>
                </div>
                <div className="text-center p-6 bg-green-50 rounded-lg">
                  <div className="w-16 h-16 flex items-center justify-center bg-green-600 rounded-full mx-auto mb-4">
                    <i className="ri-team-line text-2xl text-white"></i>
                  </div>
                  <h4 className="text-xl font-bold mb-2">50,000+ Happy Customers</h4>
                  <p className="text-gray-600">Trust built through memorable journeys</p>
                </div>
                <div className="text-center p-6 bg-orange-50 rounded-lg">
                  <div className="w-16 h-16 flex items-center justify-center bg-orange-600 rounded-full mx-auto mb-4">
                    <i className="ri-map-line text-2xl text-white"></i>
                  </div>
                  <h4 className="text-xl font-bold mb-2">28 States Covered</h4>
                  <p className="text-gray-600">Complete India travel coverage</p>
                </div>
              </div>

              <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-lg mb-8">
                <h3 className="text-2xl font-bold mb-4 text-center">Our Mission</h3>
                <p className="text-gray-700 text-center text-lg leading-relaxed max-w-3xl mx-auto">
                  To make India accessible to every traveler by providing seamless, authentic, and enriching travel experiences. We believe in sustainable tourism that benefits local communities while creating lasting memories for our guests.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <h4 className="text-xl font-bold mb-4 text-blue-600">Why Choose MaxJourneys?</h4>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-600 mr-3 mt-1"></i>
                      <span className="text-gray-700">Personalized itineraries tailored to your preferences</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-600 mr-3 mt-1"></i>
                      <span className="text-gray-700">24/7 customer support throughout your journey</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-600 mr-3 mt-1"></i>
                      <span className="text-gray-700">Best price guarantee with transparent pricing</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-600 mr-3 mt-1"></i>
                      <span className="text-gray-700">Expert local guides and authentic experiences</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-green-600 mr-3 mt-1"></i>
                      <span className="text-gray-700">Comprehensive travel insurance and safety measures</span>
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-4 text-blue-600">Our Services</h4>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <i className="ri-plane-line text-blue-600 mr-3 mt-1"></i>
                      <span className="text-gray-700">Domestic & International Flight Bookings</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-hotel-line text-blue-600 mr-3 mt-1"></i>
                      <span className="text-gray-700">Luxury Hotels & Budget Accommodations</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-car-line text-blue-600 mr-3 mt-1"></i>
                      <span className="text-gray-700">Car Rentals & Chauffeur Services</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-train-line text-blue-600 mr-3 mt-1"></i>
                      <span className="text-gray-700">Railway Reservations & Travel Passes</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-passport-line text-blue-600 mr-3 mt-1"></i>
                      <span className="text-gray-700">Visa Assistance & Documentation</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t text-center">
                <button 
                  onClick={() => setShowAboutUs(false)}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Generic Modal */}
      {renderModal()}
    </footer>
  );
}
